// extracted by mini-css-extract-plugin
module.exports = {"query-box":"query-box-1wJjX","title":"title-1a5tP","content":"content-1qoUK","dot":"dot-2rdLm","is-read":"is-read-3_Nkf"};